<div class="main-content">

    <h1>{{'UNAUTHORIZED.TITLE' | translate}}</h1>

</div>
